import fetch from '../utils/fetch';
import { companyURL } from 'endpoints';

class CompanySDK {

    getCompanies = () => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ companyURL }/companies`, {
                method: 'GET',
                headers: { 'content-type': 'application/json' }
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data.companyList );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    }

    getCompany = ( companyId ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ companyURL }/companies/${ companyId }`, {
                method: 'GET',
                headers: { 'content-type': 'application/json' }
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( {
                            id: data.data.company.id,
                            name: data.data.company.name,
                            countries: data.data.company.countryList.filter( c => c.active ),
                            identifierList: data.data.company.identifierList,
                            variableList: data.data.company.variableList,
                            primaryLogo: data.data.company.primaryLogo,
                            primaryColor: data.data.company.primaryColor
                        } );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( err.message );
            } );
        } );
    }

}

export default new CompanySDK();
